module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-60x60-09ae6ff584d853365cc9f9e11b34b534.png";